import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { account } from "../appwrite/config";
import { useAuth } from "../context/AuthContext";
import "../assets/css/Dashboard.css";
import axios from 'axios';
var _ = require('lodash');


const Dashboard = () => {
  const { role, user, loading: authLoading, isLoggedIn: authIsLoggedIn } = useAuth();

  const navigate = useNavigate();

  const [alert, setAlert] = useState({
    type: "",
    message: ""
  });

  const [isLoggedIn, setIsLoggedIn] = useState(true);

  const [loading, setLoading] = useState(true);

  const [stats, setStats] = useState({
    customers: 0,
    businesses: 0,
    categories: 0,
    coupons: 0,
    events: 0,
    courses: 0
  });

  useEffect(() => {
    document.documentElement.className = "";

    const token = sessionStorage.getItem("JWT_TOKEN");

    if (
      !authLoading &&
      authIsLoggedIn &&
      token
    ) {
      getDashboardData();
    }

  }, [authLoading, authIsLoggedIn]);

  useEffect(() => {
    const token = sessionStorage.getItem("JWT_TOKEN");

    if (
      !loading &&
      !authLoading &&
      authIsLoggedIn &&
      token &&
      stats.businesses === 0 &&
      stats.coupons === 0
    ) {
      getDashboardData();
    }
  }, [role, user]);

  const getAuthHeaders = () => {

    const token = sessionStorage.getItem('JWT_TOKEN');    
    return {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
  };

  const checkSession = async () => {

    try {

      //await account.get();

      const token = sessionStorage.getItem('JWT_TOKEN');

      if (!token) {
        setIsLoggedIn(false);
        logout();
        return;
      }

      setIsLoggedIn(true);

      await getDashboardData();

    } catch {      
      setIsLoggedIn(false);

      navigate("/");

    } finally {

      setLoading(false);

    }
  };

  const logout = async () => {

    try {
      await account.deleteSession("current");
    } catch (error) {
      console.error(error);
    }

    sessionStorage.clear();

    navigate("/");

    window.location.reload();
  };

  /*const getDashboardData = async () => {

    setLoading(true);

    await Promise.all([
      getAllCustomers(),
      getAllBusinesses(),
      getAllCategories(),
      getAllCoupons(),
      getAllEvents(),
      getAllCourses()
    ]);

    setLoading(false);
  };*/

  const getDashboardData = async () => {
    setLoading(true);

    try {
      const promises = [];

      if (role === "admin") {
        promises.push(
          getAllCustomers(),
          getAllBusinesses(),
          getAllCategories(),
          getAllCoupons(),
          getAllEvents(),
          getAllCourses()
        );
      } else if (role === "business") {
        promises.push(
          getAllBusinesses(),
          getAllCoupons(),
        );
      } else if (role === "event") {
        promises.push(
          getAllEvents()
        );
      } else if (role === "course") {
        promises.push(
          getAllCourses()
        );
      }

      await Promise.all(promises);    
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };


  const getAllCustomers = async () => {

    try {

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/listallusers`,
        {
          ...getAuthHeaders(),
          // params: {
          //   "queries[]": `equal("labels", ["customer"])`,
          // }
        }
      );

      const data = response?.data?.data || [];

      setStats((prev) => ({
        ...prev,
        customers: Array.isArray(data)
          ? data.length
          : 0,
      }));

    } catch (err) {      
      const apierror = _.get(
        err,
        ['response', 'data', 'error', 'message'],
        "Something went wrong"
      );

      setAlert({
        type: "error",
        message: apierror
      });
    }
  };

  const getAllBusinesses = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/shops`,
        {
          ...getAuthHeaders(),
          params: {
            category: 'all',
            latitude: 0,
            longitude: 0,
            radius: 0,
            userId: role === "admin" ? null : user?.$id
          }
        }
      );

      const data = response?.data?.data || [];
      // BUsiness IDs
      const businessIds = data.map((business) => business.$id);
      sessionStorage.setItem("businessIds", JSON.stringify(businessIds));

      const businessCount = response.data?.pagination?.total ?? 0;

      setStats((prev) => ({
        ...prev,
        businesses: businessCount,
      }));
    } catch (err) {
      const apierror = _.get(
        err,
        ['response', 'data', 'error', 'message'],
        "Something went wrong"
      );

      setAlert({
        type: "error",
        message: apierror
      });
    }
  };

  const getAllCategories = async () => {

    try {

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/categories`,
        {
          ...getAuthHeaders(),
          params: {
            latitude: 0,
            longitude: 0,
            radius: 0
          }
        }
      );

      const data =
        response?.data?.documents ||
        response?.data?.data ||
        [];

      setStats((prev) => ({
        ...prev,
        categories: Array.isArray(data)
          ? data.length
          : 0,
      }));

    } catch (err) {
      const apierror = _.get(
        err,
        ['response', 'data', 'error', 'message'],
        "Something went wrong"
      );

      setAlert({
        type: "error",
        message: apierror
      });
    }
  };

  const getAllCoupons = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/listallcoupons`,
        {
          ...getAuthHeaders(),
          params: {
            userId: role === "admin" ? null : user?.$id,
            page: 0,
            limit: 0
          }
        }
      );



      const data = response?.data?.data || [];
      setStats((prev) => ({
        ...prev,
        coupons: data.length,
      }));

    } catch (err) {      
      const apierror = _.get(
        err,
        ['response', 'data', 'error', 'message'],
        "Something went wrong"
      );

      setAlert({
        type: "error",
        message: apierror
      });
    }
  };

  const getAllEvents = async () => {

    try {

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/events`,
        {
          ...getAuthHeaders(),
          params: {
            latitude: 0,
            longitude: 0,
            radius: 0,
            userId: role === "admin" ? null : user?.$id
          }
        }
      );

      const data = response?.data?.data || [];

      setStats((prev) => ({
        ...prev,
        events: Array.isArray(data)
          ? data.length
          : 0,
      }));

    } catch (err) {
      const apierror = _.get(
        err,
        ['response', 'data', 'error', 'message'],
        "Something went wrong"
      );

      setAlert({
        type: "error",
        message: apierror
      });
    }
  };

  const getAllCourses = async () => {

    try {

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/courses`,
        {
          ...getAuthHeaders(),
          params: {
            latitude: 0,
            longitude: 0,
            radius: 0,
            userId: role === "admin" ? null : user?.$id
          }
        }
      );

      const data = response?.data?.data || [];

      setStats((prev) => ({
        ...prev,
        courses: Array.isArray(data) ? data.length : 0,
      }));

    } catch (err) {
      const apierror = _.get(
        err,
        ['response', 'data', 'error', 'message'],
        "Something went wrong"
      );

      setAlert({
        type: "error",
        message: apierror
      });
    }
  };

  return (
    <section className="is-title-bar">

      <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0 mb-6">
        <ul>
          <li>Admin</li>
          <li>Dashboard</li>
        </ul>
      </div>

      <div className="card dashboard-main-card">

        <header className="card-header">
          <p className="card-header-title">
            <span className="icon">
              <i className="mdi mdi-finance"></i>
            </span>

            Welcome to your Dashboard
          </p>
        </header>

        <div className="card-content">

          {loading ? (

            <div className="dashboard-loader">
              <div className="dashboard-spinner"></div>
            </div>

          ) : (

            <>
              <div className="dashboard-grid">
                {role === "admin" && (
                  <Link to={isLoggedIn ? "/users" : "/"}>
                    <div className="dashboard-stat-card customers-card">
                      <div className="dashboard-card-icon">
                        <i className="mdi mdi-account-group"></i>
                      </div>
                      <div>
                        <p className="dashboard-card-title">
                          Users
                        </p>
                        <h2 className="dashboard-card-count">
                          {stats.customers}
                        </h2>
                      </div>
                    </div>
                  </Link>
                )}
                {["admin", "business"].includes(role) && (
                  <Link to={isLoggedIn ? "/shops" : "/"}>
                    <div className="dashboard-stat-card business-card">
                      <div className="dashboard-card-icon">
                        <i className="mdi mdi-store"></i>
                      </div>

                      <div>
                        <p className="dashboard-card-title">
                          Businesses
                        </p>

                        <h2 className="dashboard-card-count">
                          {stats.businesses}
                        </h2>
                      </div>
                    </div>
                  </Link>
                )}
                {role === "admin" && (
                  <Link to={isLoggedIn ? "/categories" : "/"}>
                    <div className="dashboard-stat-card category-card">
                      <div className="dashboard-card-icon">
                        <i className="mdi mdi-shape"></i>
                      </div>

                      <div>
                        <p className="dashboard-card-title">
                          Categories
                        </p>

                        <h2 className="dashboard-card-count">
                          {stats.categories}
                        </h2>
                      </div>
                    </div>
                  </Link>
                )}
                {["admin", "business"].includes(role) && (
                  <Link to={isLoggedIn ? "/coupons" : "/"}>
                    <div className="dashboard-stat-card coupon-card">
                      <div className="dashboard-card-icon">
                        <i className="mdi mdi-ticket-percent"></i>
                      </div>

                      <div>
                        <p className="dashboard-card-title">
                          Coupons
                        </p>

                        <h2 className="dashboard-card-count">
                          {stats.coupons}
                        </h2>
                      </div>
                    </div>
                  </Link>
                )}

                {["admin", "event"].includes(role) && (
                  <Link to={isLoggedIn ? "/events" : "/"}>
                    <div className="dashboard-stat-card events-card">
                      <div className="dashboard-card-icon">
                        <i className="mdi mdi-calendar"></i>
                      </div>

                      <div>
                        <p className="dashboard-card-title">
                          Events
                        </p>

                        <h2 className="dashboard-card-count">
                          {stats.events}
                        </h2>
                      </div>
                    </div>
                  </Link>
                )}

                {["admin", "course"].includes(role) && (
                  <Link to={isLoggedIn ? "/courses" : "/"}>
                    <div className="dashboard-stat-card courses-card">
                      <div className="dashboard-card-icon">
                        <i className="mdi mdi-book-open-page-variant"></i>
                      </div>

                      <div>
                        <p className="dashboard-card-title">
                          Holidays
                        </p>

                        <h2 className="dashboard-card-count">
                          {stats.courses}
                        </h2>
                      </div>
                    </div>
                  </Link>
                )}
              </div>
            </>

          )}

        </div>
      </div >
    </section >
  );
};

export default Dashboard;